import React from 'react';

export default function ChatIcon(): JSX.Element {
  return (
    <svg viewBox="0.5 1 12 10" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <path
          d="M1.6 3h6.8c.567 0 1.034.426 1.094.973l.006.119v4.376c0 .563-.429 1.026-.98 1.085l-.12.007h-3L4.22 10.9a.301.301 0 01-.403.042l-.047-.043L2.6 9.56h-1a1.097 1.097 0 01-1.094-.972L.5 8.467V4.093c0-.563.429-1.026.98-1.086L1.6 3h6.8zm3.87 4.317H2.25c-.166 0-.3.133-.3.297 0 .165.134.298.3.298h3.22c.166 0 .3-.133.3-.298a.299.299 0 00-.3-.297zM4.1.5h6.8c.567 0 1.034.426 1.094.973l.006.119v4.376c0 .563-.429 1.026-.98 1.085l-.12.007-.4-.001v-.595h.4a.5.5 0 00.492-.407l.008-.09V1.593a.497.497 0 00-.41-.489l-.09-.008H4.1a.5.5 0 00-.492.407l-.008.09L3.599 2H3v-.408c0-.563.429-1.026.98-1.086L4.1.5h6.8zm3.65 5.477h-5.5a.299.299 0 100 .596h5.5a.3.3 0 00.3-.298.299.299 0 00-.3-.298zm-3.94-1.34H2.25a.299.299 0 100 .596h1.56c.166 0 .3-.133.3-.298a.299.299 0 00-.3-.298z"
          id="chatIcon"
        />
      </defs>
      <use fill="#FFF" fillRule="nonzero" xlinkHref="#chatIcon" />
    </svg>
  );
}
